<div *ngIf="loadingService.loading$ | async">
  <app-spinner [fullSpinner]="false"></app-spinner>
</div>

<p-toast></p-toast>
<div class="card-map">
  <section class="wrapper" *ngIf="vehicleKey">
    <div class="wrapper-div">
      <div class="header-comp-logo">
        <img
          class="montralogo2024"
          src="../../../../assets/img/common/montralogo2024.png"
          alt="logo"
        />
      </div>
      <div class="header-menu"></div>
    </div>
  </section>

  <section class="p-2" *ngIf="isError">
    @for (msg of messages; track $index) {
      <p-message [severity]="$any(msg.severity)" [closable]="false">{{
        msg.summary
      }}</p-message>
    }
  </section>
  <section class="vehicle-wrapper" *ngIf="!isError && isLoaded && vehicleKey">
    <button
      class="back-button"
      *ngIf="vehicleFromResp.length !== 1 && !popupAccess"
      (click)="back()"
    >
      <svg width="18" height="18" class="me-1">
        <use [attr.xlink:href]="'assets/img/common/sprite.svg#back-icon'" />
      </svg>
      <span>Back</span>
    </button>
    <div class="vehicle">
      <div class="v-g1">
        <div class="field">
          <div class="field-label">Vehicle Number :</div>
          <div class="field-value">
            {{ vehicleNumber }}
          </div>
        </div>
      </div>
      <div class="v-g1">
        <!-- <div class="field">
          <div class="field-label">Model :</div>
          <div class="field-value">{{ model | dash }}</div>
        </div> -->
        <div class="field">
          <div class="field-label">Created Time :</div>
          <div class="field-value">
            {{ reportingTime | dash | dateTime }}
          </div>
        </div>
      </div>
      <!-- <div class="v-g1">
        <div class="field">
          <div class="field-label">Status :</div>
          <div class="field-value status-green">Active</div>
        </div>
      </div> -->
    </div>
    <div class="counter" *ngIf="timeLeft">
      <div class="count-box">
        <div class="count-value">{{ timeLeft.days }}</div>
        <div class="count-label">Days</div>
      </div>
      <div class="seperation">|</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.hours }}</div>
        <div class="count-label">HH</div>
      </div>
      <div class="seperation">:</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.minutes }}</div>
        <div class="count-label">MM</div>
      </div>
      <div class="seperation">:</div>
      <div class="count-box">
        <div class="count-value">{{ timeLeft.seconds }}</div>
        <div class="count-label">SS</div>
      </div>
    </div>
  </section>
  <section class="vehicle-wrapper" *ngIf="!vehicleKey">
    <button class="back-button" *ngIf="!popupAccess" (click)="back()">
      <svg width="18" height="18" class="me-1">
        <use [attr.xlink:href]="'assets/img/common/sprite.svg#back-icon'" />
      </svg>
      <span>Back</span>
    </button>
    <div class="vehicle-1">
      <div class="field">
        <div class="field-label">Vehicle Number :</div>
        <div class="field-value">
          {{ plotResponse?.vehicleNumber }}
        </div>
      </div>
    </div>
  </section>
  <div class="map_wrapper">
    <div class="map-type-pos">
      <app-map-type-view
        [maps]="map"
        [trafficLive]="trafficLive"
      ></app-map-type-view>
    </div>

    <button
      class="refresh-button"
      *ngIf="showRefreshButton && !isError"
      (click)="refresh()"
    >
      <svg width="16" height="16" class="click-svg cursor-pointer big-small">
        <use
          [attr.xlink:href]="'assets/img/common/clusterTwin.svg#refresh-on-live'"
        />
      </svg>
      <span>Refresh to Update</span>
    </button>
    <div id="live-map" [class.popupMap]="popupAccess"></div>
  </div>
</div>
